import * as angular from "angular";

export class HouseOccupantV2Service {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/houseoccupant";
    }

    integrationLinks(id: string): Promise<object> {
        return this.$http.get(this.v2Root + "/integration_links/" + id);
    }
}

angular
    .module("vcServices")
    .service("HouseOccupantV2Service", HouseOccupantV2Service);
